import { c as _c } from "react/compiler-runtime";
import type { GaugeTemplateCard, LineChartTemplateCard, ValueWithTrendTemplateCard } from '@effektify/engine';
import type { ReportConfig } from '@effektify/types/definitions';
import { isLineChartCard, isSemiCircleCard, isValueWithTrendTemplate } from '@effektify/engine';
import { useMemo } from 'react';
interface HeroSlots {
  kpis: ValueWithTrendTemplateCard[];
  gauge: GaugeTemplateCard | null;
  chart: LineChartTemplateCard | null;
}
const EMPTY_SLOTS: HeroSlots = {
  kpis: [],
  gauge: null,
  chart: null
};

/**
 * Hero overview reports list their cards flat, without layout. Cards are placed by
 * variant and chart type: value cards become key figures (in list order), the first
 * semi-circle chart becomes the goal gauge and the first line chart the main chart.
 */
const getHeroSlots = (report: ReportConfig | null): HeroSlots => {
  if (!report) {
    return EMPTY_SLOTS;
  }
  return report.reduce<HeroSlots>((slots, item) => {
    if (isValueWithTrendTemplate(item)) {
      return {
        ...slots,
        kpis: [...slots.kpis, item]
      };
    }
    if (isSemiCircleCard(item) && !slots.gauge) {
      return {
        ...slots,
        gauge: item
      };
    }
    if (isLineChartCard(item) && !slots.chart) {
      return {
        ...slots,
        chart: item
      };
    }
    return slots;
  }, EMPTY_SLOTS);
};
const useHeroSlots = report => {
  const $ = _c(2);
  let t0;
  if ($[0] !== report) {
    t0 = getHeroSlots(report);
    $[0] = report;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
};
export default useHeroSlots;
export { getHeroSlots };
export type { HeroSlots };